import * as axios from "axios/index";
import {HOST_NAME} from "../ConfigProject/configProject";

const instance = axios.create({
    baseURL: `${HOST_NAME}xCircular/XCircularKeshetTeamimSignage/XCircularKeshetTeamimSignageWcfService/`,
});

export const tableAPI = {
    getDataTable(branchId, format, supplierName, productCategoryName, keywords) {
        return instance
            .post(`GetPrintableBranchPricezPromos`, {
                UserName: "kt",
                AccountRecID: "00000000-0000-0000-0000-000000000000",
                LanguageCultureCode: "he-IL",
                UILanguageCultureCode: "he-IL",
                Password: "kt",
                BranchID: branchId,
                KeshetTeamimReferenceNo: 1,
                SupplierName: supplierName,
                ProductCategoryName: productCategoryName,
                Keywords: keywords
            })
            .then((response) => {
                return response.data;
            });
        // .catch((err) => {
        //     console.log(err)
        // })
    },

    getDataTableForRegularPrices(
        branchId,
        format,
        supplierName,
        productCategoryName,
        keywords
    ) {
        return instance
            .post(`GetPrintableBranchPricezRegularItems`, {
                UserName: "kt",
                AccountRecID: "00000000-0000-0000-0000-000000000000",
                LanguageCultureCode: "he-IL",
                UILanguageCultureCode: "he-IL",
                Password: "kt",
                BranchID: branchId,
                SupplierName: supplierName,
                ProductCategoryName: productCategoryName,
                KeshetTeamimReferenceNo: 1,
                Keywords: keywords
            })
            .then((response) => {
                return response.data;
            });
        // .catch((err) => {
        //     console.log(err)
        // })
    },

    getBranchPricezPromosSignage(pageSize, saleData, branchId) {
        return instance
            .post(`GetBranchPricezPromosSignage`, {
                UserName: "kt",
                AccountRecID: "00000000-0000-0000-0000-000000000000",
                LanguageCultureCode: "he-IL",
                UILanguageCultureCode: "he-IL",
                Password: "kt",
                BranchID: branchId,
                KeshetTeamimReferenceNo: 1,
                PageSize: pageSize,
                SalesIdentifiers: saleData,
            })
            .then((response) => {
                return response;
            });
        // .catch((err) => {
        //     console.log(err)
        // })
    },

    getBranchPricesRegularItemsSignage(pageSize, regItemsData, branchId) {
        return instance
            .post(`GetBranchPricezRegularItemsSignage`, {
                UserName: "kt",
                AccountRecID: "00000000-0000-0000-0000-000000000000",
                LanguageCultureCode: "he-IL",
                UILanguageCultureCode: "he-IL",
                Password: "kt",
                BranchID: branchId,
                KeshetTeamimReferenceNo: 1,
                PageSize: pageSize,
                EffectiveBarCodes: regItemsData,
            })
            .then((response) => {
                return response;
            });
        // .catch((err) => {
        //     console.log(err)
        // })
    },

    RegisterPricezPromosSignagePrinting(branchId, pageSize, recids) {
        return instance
            .post(`RegisterPricezPromosSignagePrinting`, {
                UserName: "kt",
                AccountRecID: "00000000-0000-0000-0000-000000000000",
                LanguageCultureCode: "he-IL",
                UILanguageCultureCode: "he-IL",
                Password: "kt",
                BranchID: branchId,
                KeshetTeamimReferenceNo: 1,
                PageSize: pageSize,
                SaleIdentifiers: recids,
            })
            .then((response) => {
                return response;
            });
        // .catch((err) => {
        //     console.log(err)
        // })
    },
    RegisterPricesRegularItemsSignagePrinting(branchId, pageSize, recids) {
        return instance
            .post(`RegisterPricezRegularItemsSignagePrinting`, {
                UserName: "kt",
                AccountRecID: "00000000-0000-0000-0000-000000000000",
                LanguageCultureCode: "he-IL",
                UILanguageCultureCode: "he-IL",
                Password: "kt",
                BranchID: branchId,
                KeshetTeamimReferenceNo: 1,
                PageSize: pageSize,
                EffectiveBarCodes: recids,
            })
            .then((response) => {
                return response;
            });
        // .catch((err) => {
        //     console.log(err)
        // })
    },
};
